export const analyticEvents = {
  document: {
    downloaded: "Document.Downloaded",
  },
  simpleDocumentCreation: {
    nextSteps: {
      download: "myOverview.simpleFlowDocumentsNextSteps.download",
      register: "myOverview.simpleFlowDocumentsNextSteps.register",
      pay: "myOverview.simpleFlowDocumentsNextSteps.pay",
    },
  },
  lawdocs: {
    flowStarted: "lawdocs.flowStarted",
    completedDocument: "lawdocs.completedDocument",
    firstTimeCompletedDocument: "lawdocs.firstTimeCompletedDocument",
  },
  myOverview: {
    getReadyForTheMeeting: {
      tasks: {
        saveMetaDataPowForm: "myOverview.getReadyForTheMeeting.tasks.saveMetaDataPowForm",
        saveMetaDataWillForm: "myOverview.getReadyForTheMeeting.tasks.saveMetaDataWillForm",
        saveMetaDataOtherDocumentForm: "myOverview.getReadyForTheMeeting.tasks.saveMetaDataOtherDocumentForm",
      },
    },
  },
  // when a user comes from wordpress testaviva site (Clicking buy button on wordpress site). this event is captured with product and purchase type properties
  wordpress: {
    productsPageReferral: "wordpress.productsPageReferral",
  },
  cart: {
    addToCart: "cart.addToCart",
  },
  sidebar: {
    remove: "sidebar.remove",
    updateItemVariant: "sidebar.updateItemVariant",
    updateItemQuantity: "sidebar.updateItemQuantity",
  },
  onboarding: {
    recommendationViewed: "onboarding.recommendation.viewed",
    completed: "onboarding.completed",
  },
} as const;

export const gaEvents = {
  purchase: "purchase",
  login: "login",
  signup: "signup",
} as const;
